<template>
</template>

<script>
  export default {
    name: 'LayoutFooter'
  }
</script>

<style lang="scss" scoped>
  footer.main {
    position: fixed;
    bottom: 0;
  }
</style>
